export default __webpack_public_path__ + "static/images/list-1.27323334.jpg";